module.exports = __webpack_public_path__ + "gl.svg?f74352300b907585a4d81cd0270aaccb";